module.exports = __webpack_public_path__ + "static/TWTCTW_Square-2f031c8460320f184ad95be0b31a9995.jpg";